import { useContext, useEffect, useState } from "react"

import { useUserContext } from "../providers"
import { FeatureFlagContext } from "./FeatureFlagProvider"

/**
 * Hook to identify the current user with the feature flag client
 * This enables user-specific and percentage-based targeting
 */
export const useFeatureFlagIdentify = () => {
  const { user } = useUserContext()
  const { client } = useContext(FeatureFlagContext)
  const [isIdentified, setIsIdentified] = useState(false)

  useEffect(() => {
    if (isIdentified || !client || !user) return

    setIsIdentified(true)

    client.identify(user.id, {
      email: user.email,
      admin: user.admin,
      created_at: user.created_at,
    })
  }, [user, client, isIdentified])

  return { isIdentified }
}

